const listeners = new Set();

// Marcado quando notify() e chamado sem permissao concedida. Serve para o banner
// voltar a aparecer mesmo depois de dispensado: se o painel ja perdeu uma
// notificacao de verdade, insistir vale mais do que respeitar a soneca.
let perdeuNotificacao = false;

export const suportaNotificacao = () => typeof window !== 'undefined' && 'Notification' in window;

export const getPermissionState = () => (suportaNotificacao() ? Notification.permission : 'unsupported');

const emitir = () => {
  const estado = getPermissionState();
  listeners.forEach((cb) => {
    try {
      cb(estado);
    } catch (err) {
      console.debug('[notificacoes] listener de permissao falhou', err);
    }
  });
};

export const marcarPerdaDeNotificacao = () => {
  if (perdeuNotificacao) return;
  perdeuNotificacao = true;
  emitir();
};

export const jaPerdeuNotificacao = () => perdeuNotificacao;

/**
 * Pede a permissao ao navegador.
 *
 * IMPORTANTE: so pode ser chamada a partir de um gesto real do usuario. O codigo
 * antigo chamava requestPermission de dentro dos handlers de socket — Firefox e
 * Safari recusam o pedido fora de gesto, e a notificacao que disparou o pedido
 * era descartada. Por isso o unico caller e o botao do banner.
 */
export async function requestPermission() {
  if (!suportaNotificacao()) return 'unsupported';
  if (Notification.permission !== 'default') return Notification.permission;

  // Safari antigo so expoe a versao por callback; navegadores atuais devolvem
  // promise. Normaliza os dois formatos.
  const estado = await new Promise((resolve) => {
    try {
      const retorno = Notification.requestPermission(resolve);
      if (retorno && typeof retorno.then === 'function') retorno.then(resolve).catch(() => resolve('default'));
    } catch (err) {
      console.warn('[notificacoes] requestPermission falhou', err);
      resolve('default');
    }
  });

  if (estado === 'granted') perdeuNotificacao = false;
  emitir();
  return estado;
}

export function subscribePermission(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}
